













































import { Vue, Component } from "@/shared/vuepack";
import { useBalanceTransferStore, goToStep } from "@/employee/store/balanceTransfer";
import Button from "@/shared/components/ui/Button.vue";
import FormDownload from "@/employee/components/onboarding/balance-transfer/FormDownload.vue";

@Component({
  components: {
    Button,
    FormDownload
  }
})
export default class RolloverFormDownload extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  generateForm () {
    return this.balanceTransferStore.generateRolloverBalanceTransferForm();
  }

  goToNextStep () {
    goToStep("rollover-finish");
  }

  goToPreviousStep () {
    goToStep("rollover-details");
  }
}
